"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeServicetokens_en_us = void 0;
function backofficeServicetokens_en_us() {
    return {
        "backoffice.servicetokens.subtitle": "Servicetoken allow for authorized API calls to interact with the backoffice.",
        "backoffice.servicetokens.permissions": "Permissions",
        "backoffice.servicetokens.create": "Create servicetoken",
        "backoffice.servicetokens.edit": "Edit servicetoken",
        "backoffice.servicetokens.changelabel": "Change label",
        "backoffice.servicetokens.addpermissions": "Add permission",
        "backoffice.servicetokens.deletemessage": "Do you really want to delete this token?",
        "backoffice.servicetokens.hitreturn": "Confirm Permission with 'Return' Key",
        "backoffice.servicetokens.errors.notfound": "Servicetoken could not be found",
        "backoffice.servicetokens.errors.noid": "No ID for servicetoken provided",
        "backoffice.servicetokens.errors.cantchange": "Servicetokens can not be altered!"
    };
}
exports.backofficeServicetokens_en_us = backofficeServicetokens_en_us;
